<template>
  <FormWrapper>
    <div class="debugger-config">
      <TnHeading type="h1" size="l" align="center" class="margin-vertical-2xl">Debugger</TnHeading>
      <TnHeading type="h2" size="2xs" align="center" class="margin-bottom-xl">
        Environment: {{ environment.label }} - {{ environment.value }}
      </TnHeading>

      <form class="field-stack" @submit.prevent="handleGoClick">
        <TnTextField id="txtClientId" v-model="options.clientId" label="Client ID" />
        <TnTextField
          id="txtRedirectUri"
          v-model="options.overrideCallbackUrl"
          label="Callback URI"
          :placeholder="callbackUrl"
        />
        <TnTextField id="txtScopes" v-model="options.scope" label="Scope" />
        <TnTextField id="txtLoginHint" v-model="options.loginHint" label="Login hint" />
        <TnTextField
          id="txtForceIdp"
          v-model="options.idp"
          label="Force IdP"
          placeholder="Can be left blank"
        />
        <TnTextField
          id="txtAcr"
          v-model="options.acr"
          label="Authentication Context Class Reference (ACR)"
          placeholder="Can be left blank"
        />
        <TnTextField
          id="txtLoginContext"
          v-model="options.loginContext"
          label="Login Context"
          placeholder="Can be left blank"
        />
        <TnTextField
          id="txtLanguage"
          v-model="options.language"
          label="Language"
          placeholder="Can be left blank"
        />

        <div class="margin-top-l button-stack">
          <TnButton id="btnAuthorize" primary block text="Go" @click="handleGoClick" />
          <TnButton secondary block text="Clear" @click="clearLs" />
          <TnButton secondary danger block text="Log out" @click="logOut" />
        </div>
      </form>
    </div>
  </FormWrapper>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { TnButton, TnHeading, TnTextField } from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from './FormWrapper.vue';
import { EnvironmentService } from '@/environment';
import {
  createUserManager,
  getCallbackUrl,
  getDefaultOptions,
  loadOptions,
  saveOptions,
  type DebuggerOptions,
} from '@/views/debugger/debugger.service';

const environment = ref<Record<string, string>>({});
const options = ref<DebuggerOptions>(loadOptions());

const callbackUrl = computed(() => getCallbackUrl(environment.value.value ?? ''));

function userManager() {
  return createUserManager(environment.value.value ?? '', options.value);
}

async function handleGoClick() {
  saveOptions(options.value);

  await userManager().signinRedirect({
    login_hint: options.value.loginHint,
    acr_values: options.value.acr + (options.value.idp ? ` idp:${options.value.idp}` : ''),
    extraQueryParams: {
      amr: options.value.amr || '',
      ui_locales: options.value.language || 'no en',
      context: options.value.loginContext || 'login',
    },
  });
}

function clearLs() {
  window.localStorage.clear();
  options.value = getDefaultOptions();
}

async function logOut() {
  await userManager().signoutRedirect();
}

onMounted(async () => {
  environment.value = await EnvironmentService.getEnvironment();
});
</script>

<style scoped>
.debugger-config {
  width: 100%;
  max-width: 576px;
  margin-inline: auto;
  padding-inline: 16px;
}

.button-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
